import { IonContent, IonPage } from '@ionic/react';
import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { createAssetomponent } from '../../models/createAssetComponent';
import axios from '../../axios';

const ComponentDetail: React.FC = () => {
  const [data, setdata] = useState({
    asset: '',
    component_name: '',
    component_serial_number: '',
  });
  let location = useLocation();
  const getAssetIndividual = () => {
    const res: any = location.state;
    if (typeof res === 'string') {
      axios({
        method: 'get',
        url: `/resource/Asset Components/${res}`,
        headers: {
          Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
        },
      })
        .then((resp) => {
          console.log(resp.data.data)
          setdata(resp.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setdata(res);
    }
  };

  useEffect(() => {
    getAssetIndividual();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { t } = useTranslation();

  return (
    <IonPage>
      <Header enableBackButton='goBack' title={data.component_name} />
      <IonContent>
        <div className="preview-header">
          <div>
            <p className="preview-title">{data.component_name}</p>{' '}
            {/* <p className="preview-title-subheading">
              {t('CreateAC.component_serial_number')}: {data.component_serial_number}
            </p> */}
          </div>
          <p></p>
        </div>

        {createAssetomponent.map((item: any, index) => {
          return (
            <div className="data-list" key={`comp-detail-${index}`}>
              {item.field ? (
                <div className="preview-container">
                  <p className="preview-key">{t(`CreateAC.${item.field}`)}</p>
                  <p className="preview-value">
                    { // @ts-ignore
                      item.field === 'external_component' ? t(data[item.field])
                      // @ts-ignore
                      : data[item.field] ? data[item.field] : '-' 
                    }
                  </p>
                </div>
              ) : (
                ''
              )}
            </div>
          );
        })}
      </IonContent>
    </IonPage>
  );
};

export default ComponentDetail;
